import { render, staticRenderFns } from "./ChoiceSelectField.vue?vue&type=template&id=aa1baa1a"
import script from "./ChoiceSelectField.vue?vue&type=script&lang=ts"
export * from "./ChoiceSelectField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports